// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"6c6f7c29","917":"f76ef9a9"}[chunkId] + ".chunk.js";
};